export default Object.freeze({
  ALLOCATION_TYPES: {
    APPROPRIATION: 'approp',
    DECREASE: 'decrease',
  },
  SCROLL_OFFSETS: {
    MENU: 35,
    DASHBOARD_TABLE: 163,
  },
});
